site.faq = {
	init : function() {
		var $faq = $('#faq');
		if ($faq.length === 0) return false;

		$('.answer', $faq).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});

		$(window).resize(function() {
			$('.answer', $faq).each(function() {
				$(this).css('max-height', $(this)[0].scrollHeight);
			});
		});

		$faq.find('.question').click(function() {
			$(this).parent('li').toggleClass('open');
		});
		$faq.find('#cancel').click(function() {
			window.history.back();
		});
	}
};

//site.inits.push('site.faq.init()');
